import { Drawer } from "@JohnLewisPartnership/jl-design-system/dist/components/drawer/Drawer";

import { CreditOffersGroup } from "../SideDrawer/CreditOfferGroup/CreditOffersGroup";
import { Disclaimer } from "../SideDrawer/Disclaimer";
import { CreditIllustration } from "../../../../types/cobeTypes";
import { NonEmptyArray } from "@/types/helpers.ts";

const getCreditOffersByType = (creditOffers: CreditIllustration[]) => {
  const ibcOffersGroups: CreditIllustration[][] = [];
  const ifcOffers: CreditIllustration[] = [];

  creditOffers.forEach((creditOffer: CreditIllustration) => {
    if (creditOffer.financialProductType === "IFC") ifcOffers.push(creditOffer);

    if (creditOffer.financialProductType === "IBC") {
      const targetGroup = ibcOffersGroups.find(
        (ibcOffersGroup) =>
          ibcOffersGroup[0]?.creditRate.value === creditOffer.creditRate.value,
      );
      targetGroup
        ? targetGroup.push(creditOffer)
        : ibcOffersGroups.push([creditOffer]);
    }
  });
  return { ibcOffersGroups, ifcOffers };
};

const groupedCreditOffers = (creditOffers: CreditIllustration[]) => {
  const orderedOffers: Array<NonEmptyArray<CreditIllustration>> = [];
  creditOffers.forEach((creditOffer: CreditIllustration) => {
    const targetGroup = orderedOffers.find((group) => {
      const prevCreditOffer = group[group.length - 1];
      return (
        prevCreditOffer?.financialProductType ==
          creditOffer.financialProductType &&
        prevCreditOffer?.creditRate.value == creditOffer.creditRate.value
      );
    });
    targetGroup
      ? targetGroup.push(creditOffer)
      : orderedOffers.push([creditOffer]);
  });
  return orderedOffers;
};

interface CreditOffersSideDrawerProps {
  handleClose: () => void;
  drawerIsOpen: boolean;
  creditOffers: CreditIllustration[];
  ifcDisclaimerAnalyticsClickHandler?: (subtype: string) => void;
  ibcDisclaimerAnalyticsClickHandler?: (type: string, subtype: string) => void;
}

export const CreditOffersSideDrawer = ({
  handleClose,
  drawerIsOpen,
  creditOffers,
  ifcDisclaimerAnalyticsClickHandler,
  ibcDisclaimerAnalyticsClickHandler,
}: CreditOffersSideDrawerProps) => {
  const { ifcOffers, ibcOffersGroups } = getCreditOffersByType(creditOffers);

  const handleDisclaimerClick = () => {
    if (ifcOffers.length && ifcDisclaimerAnalyticsClickHandler) {
      ifcDisclaimerAnalyticsClickHandler("credit component - find out more");
    } else if (ibcOffersGroups.length && ibcDisclaimerAnalyticsClickHandler) {
      ibcDisclaimerAnalyticsClickHandler("pdp fs slide draw", "credit info");
    }
  };
  const groupedOffers = groupedCreditOffers(creditOffers);

  return (
    <Drawer
      isOpen={drawerIsOpen}
      onClose={handleClose}
      heading="John Lewis Money credit options"
    >
      {groupedOffers.map((creditGroup, index) => {
        return (
          <CreditOffersGroup
            creditOfferGroup={creditGroup}
            type={creditGroup[0].financialProductType}
            key={index}
          />
        );
      })}

      <Disclaimer disclaimerClickHandler={handleDisclaimerClick} />
    </Drawer>
  );
};
